import React, { useState } from 'react';
import { useEffect } from 'react';
import Select from 'react-select';
import useAxios from 'hooks/useAxios';

const NPIProviderList = ({
  tenantID,
  selectedProvider,
  onSelect,
  isMulti = false,
}) => {
  const API = useAxios();
  const [providerName, setProviderName] = useState('');
  const [providerOpt, setProviderOpt] = useState([]);
  const [providerLoading, setProviderLoading] = useState(false);

  useEffect(() => {
    if (providerOpt.length && !selectedProvider) {
      setProviderOpt([]);
    }
  }, [selectedProvider]);
useEffect(()=>{
if(providerName.length==0){
  setProviderOpt([])
}
},[providerName])
  const handleChangeProvider = async (value) => {
    setProviderName(value);
    if (!tenantID || !value) return null;

    if (value && value.length < 3) {
      if (providerOpt.length) {
        setProviderOpt([]);
      }
      return null;
    }

    setProviderLoading(true);
    try {
      const result = await API.get(
        `/${tenantID}/AutoSearch/Provider/${value}`,
        { hideLoader: true }
      );
      if (result?.data?.length > 0) {
        setProviderOpt(result.data);
        setProviderLoading(false);
      } else {
        setProviderOpt([]);
        setProviderLoading(false);
      }
    } catch (error) {
      setProviderLoading(false);
    }
  };

  const onSelectProvider = (provider) => {
    onSelect(provider);
  };

  return (
    <Select
      className='form-field-large inner-shadow-field'
      classNamePrefix='select'
      IndicatorSeparator
      isClearable={true}
      isSearchable={true}
      isLoading={providerLoading}
      placeholder='Enter NPI or Provider Name'
      name='color'
      options={providerOpt}
      inputValue={providerName}
      value={selectedProvider}
      onInputChange={handleChangeProvider}
      onChange={onSelectProvider}
      getOptionLabel={(option) => option.description}
      getOptionValue={(option) => option.id}
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }}
      styles={{
        menu: (provided) => ({
          ...provided,
          zIndex: 99,
        }),
      }}
      isMulti={isMulti}
    />
  );
};

export default NPIProviderList;
